import { Col, Form, Row } from 'antd'
import { FC } from 'react'
import { useForm } from 'antd/es/form/Form'
import Stamp from './components/form-items/stamp/stamp'
// import Number from './components/form-items/number/number'
import Comment from './components/form-items/comment/comment'
import EstimatedDate from './components/form-items/estimated-date/estimated-date'
import Quantity from './components/form-items/quantity/quantity'
import StampOrder from '../../../../../../../types/api/stamp-order'
import getInitialValues from './helpers/get-initial-values'
import Save from './components/save/save'
import EndDate from './components/form-items/end-date/end-date'
import OrderStatus from './components/form-items/order-status/order-status'
import Initiator from './components/form-items/initiator/initiator'
import Price from './components/form-items/price/price'
import Title from 'antd/es/typography/Title'
import WriteOff from './components/write-off/write-off'

interface StampOrderFormProps {
    stampOrder?: StampOrder
    copy?: boolean
}

const StampOrderForm: FC<StampOrderFormProps> = ({ stampOrder, copy }) => {
    const [form] = useForm()
    // TODO: необходимо для копии указывать дефолтные поля Статус заказа = Создан, Факт дата отгру = пусто
    const initialValues = getInitialValues(stampOrder)

    return (
        <Form layout={'vertical'} form={form} initialValues={initialValues}>
            <Row gutter={18}>
                {/* <Col sm={4}>
                    <Number />
                </Col> */}
                <Col sm={4}>
                    <Stamp />
                </Col>
                <Col sm={4}>
                    <Quantity />
                </Col>
                <Col sm={4}>
                    <Initiator />
                </Col>
                <Col sm={4}>
                    <Price />
                </Col>
            </Row>
            <Row gutter={18}>
                <Col sm={4}>
                    <EstimatedDate />
                </Col>
                <Col sm={4}>
                    <EndDate />
                </Col>
                <Col sm={4}>
                    <OrderStatus />
                </Col>
                <Col sm={8}>
                    <Comment />
                </Col>
            </Row>
            {copy && (
                <Row gutter={18}>
                    <Col sm={24}>
                        <Title level={2}>Укажите списание штампа</Title>
                    </Col>
                    <Col sm={12}>
                        <WriteOff />
                    </Col>
                </Row>
            )}
            <Save stampOrder={stampOrder} copy={copy} />
        </Form>
    )
}

export default StampOrderForm
